// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"a3b5a82b","142":"d84af3e8","188":"57e913de","518":"4d3263df","519":"2dadc81c","546":"0f433b3c","571":"a2932c8b","819":"391e04a2","873":"73849000"}[chunkId] + ".css";
};